'use client';

import CaseSlider from '@/app/(public)/translate/showcase/case-slider';
import { OBJECT_STORAGE_URL } from '@/lib/constants';
import { cn } from '@/lib/utils';
import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';

const TranslateWidget = ({ className }: { className?: string }) => {
  return (
    <div className={cn('relative max-w-2xl mx-auto', className)}>
      <Tabs defaultValue="charts">
        <TabsList className="w-full">
          <TabsTrigger value="charts">图表</TabsTrigger>
          <TabsTrigger value="columns">双栏</TabsTrigger>
          <TabsTrigger value="table">表格</TabsTrigger>
          <TabsTrigger value="formula">公式</TabsTrigger>
          <TabsTrigger value="word">图文混排</TabsTrigger>
        </TabsList>
        <TabsContent value="charts">
          <Card>
            <CardContent className="p-6">
              <CaseSlider
                first={`${OBJECT_STORAGE_URL}/translate/showcase/img/charts_before.jpg`}
                second={`${OBJECT_STORAGE_URL}/translate/showcase/img/charts_after.jpg`}
              />
            </CardContent>
          </Card>
        </TabsContent>
        <TabsContent value="columns">
          <Card>
            <CardContent className="p-6">
              <CaseSlider
                first={`${OBJECT_STORAGE_URL}/translate/showcase/img/columns_before.jpg`}
                second={`${OBJECT_STORAGE_URL}/translate/showcase/img/columns_after.jpg`}
              />
            </CardContent>
          </Card>
        </TabsContent>
        <TabsContent value="table">
          <Card>
            <CardContent className="p-6">
              <CaseSlider
                first={`${OBJECT_STORAGE_URL}/translate/showcase/img/table_before.jpg`}
                second={`${OBJECT_STORAGE_URL}/translate/showcase/img/table_after.jpg`}
              />
            </CardContent>
          </Card>
        </TabsContent>
        <TabsContent value="formula">
          <Card>
            <CardContent className="p-6">
              <CaseSlider
                first={`${OBJECT_STORAGE_URL}/translate/showcase/img/formula_before.jpg`}
                second={`${OBJECT_STORAGE_URL}/translate/showcase/img/formula_after.jpg`}
              />
            </CardContent>
          </Card>
        </TabsContent>
        <TabsContent value="word">
          <Card>
            <CardContent className="p-6">
              <CaseSlider
                first={`${OBJECT_STORAGE_URL}/translate/showcase/img/word_before.jpg`}
                second={`${OBJECT_STORAGE_URL}/translate/showcase/img/word_after.jpg`}
              />
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default TranslateWidget;
